// extracted by mini-css-extract-plugin
module.exports = {"swiperSlide":"Slide_swiperSlide__3OlCV","row":"Slide_row__IVBoa","swiper-slide":"Slide_swiper-slide__FJiSq"};